import React from 'react';
import TextField from '@mui/material/TextField';

import FormControl from '@mui/material/FormControl';

import { Controller } from "react-hook-form";

interface IProps {
  name: string
  error?: any
  label?: string
  control: any
  isRequired?: boolean
  disabled?: boolean
  type?: string
}

const FileField = React.forwardRef<HTMLInputElement, IProps>((props: IProps, ref) => {
  const { name, error, label, control, isRequired } = props;

  return (
    <FormControl fullWidth>
      <Controller
        control={control}
        name={name}
        render={({ field }) => (
          <TextField
            {...field}
            value={field.value || ''}
            error={!!error}
            InputLabelProps={{ shrink: true }}
            helperText={error ? error.message : null}
            type="file"
            inputRef={ref}
            inputProps={{
              'data-testid': field.name
            }}
            required={isRequired}
            label={label}
          />
        )}
      // rules={{ required: isRequired }}
      />
    </FormControl>
  );
});

FileField.defaultProps = {
  isRequired: false,
};

export { FileField };
